import { render } from "./OurCoreServiceAboutUs.vue?vue&type=template&id=ad995f40&scoped=true"
import script from "./OurCoreServiceAboutUs.vue?vue&type=script&lang=js"
export * from "./OurCoreServiceAboutUs.vue?vue&type=script&lang=js"

import "./OurCoreServiceAboutUs.vue?vue&type=style&index=0&id=ad995f40&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad995f40"]])

export default __exports__